<script>
import { mapState, mapActions } from 'vuex'
import appData from '@/data'

export default {
   data() {
      return {
         item: {},
         table1: [],
         table2: [],
         table3: [],
         keteranganIzinList: [],
      }
   },
   computed: {
      ...mapState({
         myItem: state => state.OssBidangUsaha.item,
         myIdProyek: state => state.OssBidangUsaha.idProyek,
      }),
      isLoading() {
         return this.$store.state.isLoading
      },
      skalaUsaha() {
         const data = appData.skalaUsaha
         return status => {
            if (status == null || status === '') return '-'
            const s = String(status).trim()
            if (data[s]) return data[s]
            // Tangani kode numerik tanpa leading zero, misal 1 -> 01
            const padded = s.padStart(2, '0')
            if (data[padded]) return data[padded]
            // Tangani jika API mengirimkan label, misal "Mikro"
            const lower = s.toLowerCase()
            const found = Object.entries(data).find(([, text]) => text.toLowerCase() === lower)
            if (found) return found[1]
            return s
         }
      },
      statusResiko() {
         const data = appData.statusResiko
         return status => {
            if (status == null || status === '') return '-'
            const s = String(status).trim()
            if (data[s]) return data[s]
            // Tangani kode lowercase, misal "r" -> "R"
            const upper = s.toUpperCase()
            if (data[upper]) return data[upper]
            // Tangani jika API mengirimkan label, misal "Rendah"
            const lower = s.toLowerCase()
            const found = Object.entries(data).find(([, text]) => text.toLowerCase() === lower)
            if (found) return found[1]
            return '-'
         }
      },
      sektorName() {
         const data = appData.sektor
         return status => {
            if (status == null || status === '') return '-'
            const s = String(status).trim()
            if (data[s]) return data[s]
            // Tangani kode tanpa leading zero, misal 15 -> 015
            const padded = s.padStart(3, '0')
            if (data[padded]) return data[padded]
            // Tangani jika API mengirimkan nama sektor langsung
            const lower = s.toLowerCase()
            const found = Object.entries(data).find(([, text]) => text.toLowerCase() === lower)
            if (found) return found[1]
            return s
         }
      },
      statusProyek() {
         const data = appData.statusProyek
         return status => {
            if (status == null || status === '') return '-'
            const s = String(status).trim()
            if (data[s]) return data[s]
            // Tangani jika API mengirimkan label status langsung
            const lower = s.toLowerCase()
            const found = Object.entries(data).find(([, text]) => text.toLowerCase() === lower)
            if (found) return found[1]
            return s
         }
      },
   },
   watch: {
      isLoading(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
      myItem(item) {
         this.generateTable(item)
      },
      myIdProyek: {
         immediate: true,
         async handler(val) {
            await this.getItem(val).then(() => { this.item = this.myItem })
         },
      },
   },
   methods: {
      ...mapActions({
         getItem: 'OssBidangUsaha/getItem',
      }),
      resolveSatuanLuas(item) {
         const candidates = [
            'kd_satuan_luas',
            'satuan_luas',
            'kd_satuan_luas_tanah',
            'satuan_luas_tanah',
            'kd_satuan_lahan',
            'satuan_lahan',
            'satuan_tanah',
            'kd_satuan',
            'satuan',
         ]
         const key = candidates.find(k => item[k] != null && item[k] !== '')
         return key ? item[key] : ''
      },
      formatLuas(val, satuan) {
         const satuanLuasMap = {
            '01': 'm²',
            '02': 'ha',
         }
         if (val === null || val === undefined || val === '') return '-'
         const num = Number(val)
         if (Number.isNaN(num)) return '-'
         const satuanLabel = satuanLuasMap[satuan || ''] || satuan || ''
         return `${num.toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${satuanLabel}`.trim()
      },
      convertHtml2List(data) {
         if (!data || !data.keterangan_izin) {
            return [`Status Kode : ${data && data.status != null ? data.status : '-'}`]
         }
         const cleanedText = String(data.keterangan_izin).replace(/<br\s*\/?>/gi, '\n')
         const itemsArray = cleanedText.split('\n')
         const statusList = []
         itemsArray.forEach(itemText => {
            const trimmedText = itemText.trim()
            if (trimmedText) statusList.push(trimmedText)
         })
         statusList.push(`Status Kode : ${data.status}`)
         return statusList
      },
      generateTable(item) {
         const created = item.created ? this.$moment(item.created).utc().format('DD MMMM YYYY') : '-'
         const updated = item.updated ? this.$moment(item.updated).utc().format('DD MMMM YYYY') : '-'

         this.keteranganIzinList = this.convertHtml2List({
            keterangan_izin: item.keterangan_izin,
            status: item.status,
         })

         const mesinPeralatan = (Number(item.mesin_peralatan) || 0) + (Number(item.mesin_peralatan_usd) || 0)

         this.table1 = [
            { name: 'Nama Usaha / Kegiatan', value: item.nama_proyek || '-' },
            { name: 'KBLI', value: item.kbli || '-' },
            { name: 'Judul KBLI', value: item.kbli_nama || '-' },
            { name: 'Sektor', value: this.sektorName(item.sektor) },
            { name: 'Resiko', value: this.statusResiko(item.kd_resiko) },
            { name: 'Skala Usaha', value: this.skalaUsaha(item.kd_skala_usaha) },
            { name: 'Luas Lahan Usaha', value: this.formatLuas(item.luas_tanah, this.resolveSatuanLuas(item)) },
            { name: 'Alamat Usaha', value: item.alamat_usaha || '-' },
            { name: 'Kelurahan/Desa', value: item.kelurahan || '-' },
            { name: 'Kecamatan', value: item.kecamatan || '-' },
         ]

         this.table2 = [
            { name: 'Tanah', value: this.$options.filters.formatNumber(item.pembelian_pematangan_tanah) },
            { name: 'Bangunan Gedung', value: this.$options.filters.formatNumber(item.bangunan_gedung) },
            { name: 'Mesin/Peralatan', value: this.$options.filters.formatNumber(mesinPeralatan) },
            { name: 'Modal Kerja', value: this.$options.filters.formatNumber(item.modal_kerja) },
            { name: 'Lainnya', value: this.$options.filters.formatNumber(item.lain_lain) },
            { name: 'Total', value: this.$options.filters.formatNumber(item.jumlah_investasi) },
         ]

         this.table3 = [
            { name: 'Status', value: this.keteranganIzinList.join('\n') },
            { name: 'TKI', value: `${item.jumlah_tenaga_kerja || 0} Orang` },
            { name: 'TKA', value: `${item.jumlah_tenaga_kerja_asing || 0} Orang` },
            // { name: 'Status Syarat', value: item.status_pemenuhan_syarat || '-' },
            // { name: 'Status Pernyataan', value: item.status_pernyataan || '-' },
            { name: 'Id Proyek', value: item.id_proyek || '-' },
            { name: 'Dibuat', value: created },
            { name: 'Diubah', value: updated },
         ]
      },
   },
}
</script>

<template>
   <b-card class="proyek-detail shadow-sm border-0" no-body>
      <b-card-header class="bg-transparent border-bottom py-1">
         <div class="d-flex align-items-center">
            <b-avatar variant="primary" size="lg" class="shadow-sm mr-2">
               <feather-icon size="24" icon="FileTextIcon" />
            </b-avatar>
            <div class="d-flex flex-column">
               <h4 class="mb-0 font-weight-bolder text-body-heading">
                  {{ myItem.nama_perusahaan || 'Detail Proyek' }}
               </h4>
               <small class="text-muted">
                  NIB: {{ myItem.nib || '-' }}
               </small>
            </div>
         </div>
      </b-card-header>

      <b-card-body>
         <b-row>
            <b-col cols="12" lg="4" class="mb-2 mb-lg-0">
               <b-card class="shadow h-100 detail-card" header="Informasi Usaha" header-class="font-weight-bold text-body border-bottom">
                  <b-table-simple small borderless hover class="mb-0">
                     <b-tbody>
                        <b-tr v-for="(row, index) in table1" :key="`t1-${index}`">
                           <b-td class="text-muted font-weight-bold border-0 py-1">
                              {{ row.name }}
                           </b-td>
                           <b-td class="text-right text-break border-0 py-1">
                              {{ row.value }}
                           </b-td>
                        </b-tr>
                     </b-tbody>
                  </b-table-simple>
               </b-card>
            </b-col>
            <b-col cols="12" lg="4" class="mb-2 mb-lg-0">
               <b-card class="shadow h-100 detail-card" header="Modal Usaha" header-class="font-weight-bold text-body border-bottom">
                  <b-table-simple small borderless hover class="mb-0">
                     <b-tbody>
                        <b-tr v-for="(row, index) in table2" :key="`t2-${index}`">
                           <b-td class="text-muted font-weight-bold border-0 py-1">
                              {{ row.name }}
                           </b-td>
                           <b-td class="text-right text-break border-0 py-1">
                              {{ row.value }}
                           </b-td>
                        </b-tr>
                     </b-tbody>
                  </b-table-simple>
               </b-card>
            </b-col>
            <b-col cols="12" lg="4">
               <b-card class="shadow h-100 detail-card" header="Status & Keterangan" header-class="font-weight-bold text-body border-bottom">
                  <b-table-simple small borderless hover class="mb-0">
                     <b-tbody>
                        <b-tr v-for="(row, index) in table3" :key="`t3-${index}`">
                           <b-td class="text-muted font-weight-bold border-0 py-1">
                              {{ row.name }}
                           </b-td>
                           <b-td class="text-right text-break border-0 py-1" style="white-space: pre-line;">
                              {{ row.value }}
                           </b-td>
                        </b-tr>
                     </b-tbody>
                  </b-table-simple>
               </b-card>
            </b-col>
         </b-row>
      </b-card-body>
   </b-card>
</template>

<style lang="scss" scoped>
.proyek-detail {
   .table td {
      vertical-align: middle;
   }
   .detail-card {
      border-left: 4px solid #7367f0 !important;
   }
}
</style>
